import React from 'react'
import {Table as UxTable} from '@deere/ux.uxframe-react'
import {getAnswerLabel, getTranslation} from '../../utils/utils'

export default function TableCustomReview({questions,answers}){
    const questionTitle = questions ? questions.find(q => q.type === 'FLEX_TITLE'):null;
    const listQuestions = questions ? questions.filter(q => q.type === 'FLEX_TABLE'):null;
    const colNames = listQuestions[0]?[listQuestions[0],...listQuestions[0].dependentQuestions]:null;

    function createDependentCol(question){
        if(question.type === 'OPTION' || question.type === 'OPEN'){
            return <td className='p-1' key={question.id}>
                        <h6>{getAnswerLabel(question,answers)}</h6>
             </td>
        }
        return null;
    }
    return (
        <>
        <UxTable striped hover size="sm" >
        <caption>{getTranslation(questionTitle, 'text')}</caption>
        <thead>
            <tr>
                {
                    colNames?colNames.map((qt,index) => 
                        <th scope="col" className="p-1 text-center" key={index}>{getTranslation(qt, 'text')}</th>
                    ):<></>
                }
            </tr>
        </thead>
        <tbody>
            {
                listQuestions.map((q,index)=>
                    <tr key={index}>
                        <td className='p-1'>
                            {getTranslation(q.selections[0], 'text')}
                        </td>
                        {q.dependentQuestions.sort((a, b) => (a.id > b.id) ? 1 : -1).map((dq,dIndex) => createDependentCol(dq,dIndex))}
                    </tr>)
            }
        </tbody>
        </UxTable>
        </>
    )
}

